<div class="center bdo-space--bottom" >
  <div class="iconSize">
      <bdo-svg [name]="iconName" styling="bdo-svg bdo-svg--secondary"></bdo-svg>
  </div>
</div>

<ng-content></ng-content>
